import Layers from "slotworks/graphics/layers/layers";
import AbstractTextControl from "slotworks/smart-ui/controls/abstract/abstract-text-control";
import { Control } from "slotworks/smart-ui/controls/control";
import ControlOptions from "slotworks/smart-ui/options/control-options";
import HeadlessSmartUIGroup from "slotworks/smart-ui/smart-ui-group";
import { Services } from "../../../services/services";

export default class AutoplaysTextControl extends AbstractTextControl implements Control {

    public setup(name: string, layer: Layers, assetName: string, assetNames: string[], smartUIGroup: HeadlessSmartUIGroup) {
        super.setup(name, layer, assetName, assetNames, smartUIGroup);

        this.text.setAutoResize(true);
    }

    public updateOptions(options: ControlOptions) {
        super.updateOptions(options);
        let text = "";
        if (this.options.autoplays && this.options.autoplays.currentValue) {

            if (this.options.autoplays.currentValue === Infinity) {
                text = Services.translations.get("infinity");
            } else {
                text = this.options.autoplays.currentValue.toString();
            }
        }

        this.text.setText(text);
    }
}
